import React from 'react';
const FOOTER_LINKS = ['About', 'Contact', 'Editorial Policy', 'Privacy Policy', 'Terms'];
export function SiteFooter() {
  return <footer className="mt-20 border-t border-rule bg-paper-tint" data-id="element-48" data-mp="3r8rk4z3akq2l">
      <div className="mx-auto max-w-shell px-5 py-12 sm:px-8" data-id="element-49" data-mp="3mgrcslkw6uvz">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between" data-id="element-50" data-mp="3mf6i8vykvby4">
          <div data-id="element-51" data-mp="3hglsjqgycanx">
            <p className="font-sans text-[15px] font-bold uppercase tracking-[0.18em] text-ink" data-id="element-52" data-mp="3dgur8stsuc55">
              California News
            </p>
            <p className="mt-2 font-sans text-[13px] text-ink-muted" data-id="element-53" data-mp="38gyqd2gef0tt">californianews.online</p>
          </div>

          <nav aria-label="Footer" data-id="element-54" data-mp="33j6xo67xjaok">
            <ul className="flex flex-wrap gap-x-7 gap-y-3" data-id="element-55" data-mp="2yjlneznb7fwj">
              {FOOTER_LINKS.map(link => <li key={link} data-id="element-56" data-mp="11rbt0ak3c6fu">
                  <a href="#" className="font-sans text-[13px] text-ink-soft transition-colors duration-150 ease-out hover:text-ink" data-id="element-57" data-mp="11q8zduvdvpw8">
                    {link}
                  </a>
                </li>)}
            </ul>
          </nav>
        </div>

        <div className="mt-10 border-t border-rule pt-6" data-id="element-58" data-mp="1arj8ydbcyemm">
          <p className="font-sans text-[12px] text-ink-faint" data-id="element-59" data-mp="vt7b43c90ztv">
            © California News. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}